<template>
<nav id="site-navigation" class="gb-wave-nav has-branding main-navigation nav-align-right" aria-label="Primary">
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <router-link :to="homeTarget" title="GB Wave" rel="home">
          <img class="header-image is-logo-image" alt="GB Wave" src="@/assets/gb-wave-logo.webp" title="GB Wave">
        </router-link>
      </div>
      <p class="main-title">
        <router-link :to="homeTarget" rel="home">GB Wave</router-link>
        <span class="nav-free-badge">{{ labels.badge }}</span>
      </p>
    </div>

    <button
      type="button"
      class="menu-toggle"
      :aria-expanded="isMenuClicked ? 'true' : 'false'"
      aria-label="Toggle menu"
      @click="isMenuClicked = !isMenuClicked">
      <img src="@/assets/menu.svg" alt="" v-if="!isMenuClicked">
      <img src="@/assets/xmark-black.svg" alt="" v-else>
    </button>

    <div id="primary-menu" class="main-nav" :class="{ 'is-open': isMenuClicked }">
      <ul class="menu sf-menu">
        <li class="menu-item">
          <router-link :to="homeTarget" exact @click.native="closeMenu">{{ labels.home }}</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/download/" @click.native="closeMenu">{{ labels.download }}</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/old-versions/" @click.native="closeMenu">{{ labels.oldVersion }}</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/guides/" @click.native="closeMenu">{{ labels.guides }}</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/troubleshooting/" @click.native="closeMenu">{{ labels.troubleshooting }}</router-link>
        </li>
      </ul>
    </div>

    <div class="language-switcher">
      <button type="button" class="language-switcher__trigger" aria-haspopup="true">
        <span class="language-switcher__flag">{{ activeLanguage.flag }}</span>
        <span>{{ activeLanguage.label }}</span>
      </button>
      <ul class="language-switcher__menu" aria-label="Language">
        <li v-for="option in languages" :key="option.code">
          <router-link
            v-if="option.to"
            :to="option.to"
            class="language-switcher__option"
            :class="{ 'is-active': selectedLanguage === option.code }"
            @click.native="closeMenu">
            <span class="language-switcher__flag">{{ option.flag }}</span>
            <span>{{ option.label }}</span>
          </router-link>
          <span
            v-else
            class="language-switcher__option language-switcher__option--disabled"
            :class="{ 'is-active': selectedLanguage === option.code }">
            <span class="language-switcher__flag">{{ option.flag }}</span>
            <span>{{ option.label }}</span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
export default {
  name: 'HeadNav',
  props: {
    selectedLanguage: {
      type: String,
      default: 'en',
    },
    page: {
      type: String,
      default: 'gb',
    },
    gotodownload: {
      type: Function,
      default: null,
    },
    apk: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isMenuClicked: false,
      languages: [
        { code: 'en', label: 'English', flag: 'EN', to: { name: 'en-gb' } },
        { code: 'id', label: 'Indonesia', flag: 'ID', to: { name: 'id-gb' } },
      ],
    };
  },
  computed: {
    homeTarget() {
      return this.selectedLanguage === 'id' ? { name: 'id-gb' } : { name: 'en-gb' };
    },
    activeLanguage() {
      return this.languages.find((item) => item.code === this.selectedLanguage) || this.languages[0];
    },
    labels() {
      if (this.selectedLanguage === 'id') {
        return {
          badge: 'Gratis',
          home: 'Beranda',
          download: 'Unduh',
          oldVersion: 'Versi Lama',
          guides: 'Panduan',
          troubleshooting: 'Bantuan',
        };
      }

      return {
        badge: 'Free to Use',
        home: 'Home',
        download: 'Download',
        oldVersion: 'Old Version',
        guides: 'Guides',
        troubleshooting: 'Troubleshooting',
      };
    },
  },
  methods: {
    closeMenu() {
      this.isMenuClicked = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/gb-wave-home.scss';

#site-navigation {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 0 rgba(40, 167, 69, 0.08), 0 8px 24px rgba(13, 61, 42, 0.06);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.inside-navigation {
  /* 与首页正文 / Hero 同宽对齐 */
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  padding: 8px 24px;
  box-sizing: border-box;
  min-height: 0;
  position: relative;
}

.navigation-branding {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 0;
  margin-right: auto;
  flex-shrink: 0;
}

.main-nav {
  margin-left: auto;
  flex: 0 0 auto;
}

.menu {
  list-style: none !important;
  list-style-type: none !important;
  margin: 0 !important;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 2px;
}

.site-logo a {
  display: flex;
  align-items: center;
  line-height: 0;
}

.site-logo img {
  display: block;
  height: 36px;
  width: auto;
  padding: 0;
  transition: transform 0.25s cubic-bezier(0.22, 1, 0.36, 1);
}

.site-logo a:hover img {
  transform: scale(1.04);
}

.main-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  line-height: 1.2;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.main-title a {
  color: #0d3d2a;
  text-decoration: none;
  transition: color 0.18s ease;
}

.main-title a:hover {
  color: var(--gb-wave-green, #28a745);
}

.menu-item {
  list-style: none !important;
  list-style-type: none !important;
}

.menu-item a {
  position: relative;
  text-decoration: none;
  color: #243041;
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1.35;
  padding: 7px 11px;
  display: block;
  border-radius: 999px;
  transition: color 0.18s ease, background 0.18s ease;
}

.menu-item a:hover,
.menu-item a.router-link-exact-active {
  color: var(--gb-wave-green, #28a745);
  background: rgba(40, 167, 69, 0.08);
}

.language-switcher {
  position: relative;
  margin-left: 8px;
  flex: 0 0 auto;
}

.language-switcher::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 0;
  left: -16px;
  height: 10px;
}

.language-switcher__trigger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 11px;
  border: 1px solid #dfece4;
  border-radius: 999px;
  background: #fff;
  color: #243041;
  font-size: 0.84rem;
  font-weight: 700;
  cursor: pointer;
}

.language-switcher__flag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  min-width: 26px;
  height: 18px;
  border-radius: 4px;
  background: #eaf7ee;
  color: #0d3d2a;
  font-size: 0.66rem;
  font-weight: 900;
  line-height: 1;
}

.language-switcher__menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1001;
  min-width: 168px;
  margin: 0;
  padding: 6px;
  list-style: none !important;
  list-style-type: none !important;
  border: 1px solid #dfece4;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 14px 30px rgba(18, 76, 43, 0.12);
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.language-switcher__menu li {
  margin: 0;
  padding: 0;
  list-style: none !important;
  list-style-type: none !important;
}

.language-switcher__menu li::marker {
  content: "";
}

.language-switcher:hover .language-switcher__menu,
.language-switcher:focus-within .language-switcher__menu {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.language-switcher__option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  border-radius: 8px;
  color: #243041;
  font-size: 0.86rem;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
}

.language-switcher__option:hover,
.language-switcher__option.is-active {
  color: var(--gb-wave-green, #28a745);
  background: rgba(40, 167, 69, 0.08);
}

.language-switcher__option--disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
}

.menu-toggle img {
  width: 24px;
  height: 24px;
}

@media (max-width: 900px) {
  .inside-navigation {
    flex-wrap: wrap;
  }

  .menu-toggle {
    display: block;
    margin-left: auto;
  }

  .main-nav {
    margin-left: 0;
    flex: 1 1 100%;
  }

  .language-switcher {
    margin-left: 8px;
  }

  .main-nav .menu {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    padding: 8px 0;
    z-index: 1000;
  }

  .main-nav.is-open .menu {
    display: flex;
  }

  .menu-item {
    width: 100%;
    text-align: center;
  }
}
</style>
